export const isEqual = (value1: string, value2: string): boolean => {
   let isEqual = true;
   if (value1.trim() !== value2.trim()) {
      isEqual = false;
   }

   return isEqual;
};
